import React from 'react'
import { useNavigate } from 'react-router'
import { Table } from 'react-bootstrap'
import { trim } from 'lodash'
import * as s from './NFLStandings.scss'
import CloudinaryImage from '../../../Cloudinary/CloudinaryImage'

const NFLStandingsDivision = ({ division = null, seasonName = '' }) => {

    const navigate = useNavigate()

    if (!division || !division.conference || !division.standings || !seasonName) return null
    return (
        <section className={s.divisionCard}>
            <h3 className={s.divisionTitle}>{division.conference} {division.division}</h3>
            <Table responsive='sm' className={s.standingsTable}>
                <thead>
                    <tr>
                        <th>Team</th>
                        <th className='text-end'>W</th>
                        <th className='text-end'>L</th>
                        <th className='text-end'>T</th>
                        <th className='text-end'>.pct</th>
                        <th className={`text-end ${s.secondaryStat}`}>PF</th>
                        <th className={`text-end ${s.secondaryStat}`}>PA</th>
                    </tr>
                </thead>
                <tbody>
                {division.standings && division.standings.map(x => {
                    const city = x.city || trim((x.nflTeam || '').replace(x.mascot || '', ''))
                    const mascot = x.mascot || x.nflTeam
                    return (
                    <tr key={`nfl-division-row-${seasonName}-${division.conference}-${division.division}-${x.teamId}`}>
                        <td className={s.teamCell}>
                            <button type='button' className={s.teamButton}
                                onClick={() => seasonName && x.mascot ? navigate(`/football/nfl-team-analysis/${seasonName}/${x.mascot.toLowerCase()}`) : null}>
                                <CloudinaryImage className={s.teamAvatar} publicId={`/football/nfl-team-small-avatars/${(x.mascot || '').toLowerCase()}`} />
                                <span className={s.teamIdentity}>
                                    <span className={s.city}>{city}</span>
                                    <span className={s.mascot}>{mascot}</span>
                                </span>
                            </button>
                        </td>
                        <td className={`text-end ${s.statValue}`}>{x.w}</td>
                        <td className={`text-end ${s.statValue}`}>{x.l}</td>
                        <td className={`text-end ${s.statValue}`}>{x.t}</td>
                        <td className={`text-end ${s.statValue}`}>{x.winPctStr}</td>
                        <td className={`text-end ${s.statValue} ${s.secondaryStat}`}>{x.pf}</td>
                        <td className={`text-end ${s.statValue} ${s.secondaryStat}`}>{x.pa}</td>
                    </tr>
                    )
                })}
                </tbody>
            </Table>
        </section>
    )
}

export default NFLStandingsDivision
